<button mat-button (click)="openSettingsDialog()" matTooltip="{{ 'header.settings' | translate }}"><mat-icon mat-list-icon>settings</mat-icon></button>